var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 16","name":"gc-arrow-right"}},[_c('path',{style:({
      fill: _vm.color
    }),attrs:{"d":"M5.7 8L0 13.8 2.1 16 10 8 2.1 0 0 2.2 5.7 8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }